import logo from '../assets/img/logo.png'
import hero01 from '../assets/img/hero01.png'
import hero02 from '../assets/img/hero02.png'
import menu from '../assets/img/menu.png'
import gallery01 from '../assets/img/Beef-Bulgogi.png'
import gallery02 from '../assets/img/Chicken-Fried-Noodle.png'
import gallery03 from '../assets/img/Chicken-Katsu.png'
import gallery04 from '../assets/img/Combination-Tempura.png'
import gallery05 from '../assets/img/Kids-Chicken-Katsu.png'
import gallery06 from '../assets/img/Party-sushi.png'
import gallery07 from '../assets/img/Pork-Teriyaki.png'
import gallery08 from '../assets/img/Salmon-Sashimi.png'
import gallery09 from '../assets/img/Tempura-Don.png'
import sushi from '../assets/img/sushi.jpg'
import about from '../assets/img/about.jpg'
import seaweed from '../assets/img/seaweed.jpg'
import map from '../assets/img/map-pin.png'

export default {
  logo,
  hero01,
  hero02,
  menu,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  gallery05,
  gallery06,
  gallery07,
  gallery08,
  gallery09,
  sushi,
  about,
  seaweed,
  map,
}
